<template>
  <p :class="[{ bold }, variant]"><slot/></p>
</template>


<script>
export default {
  name: 'AppText',

  props: {
    bold: Boolean,
    variant: String,
  },
};
</script>


<style lang="scss" scoped>
p {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: var(--color-dark);
  letter-spacing: calc(1em / -50);

  &.bold {
    font-weight: bold;
  }
  
  &.secondary {
    color: var(--color-secondary);
  }

  &.white {
    color: var(--color-white);
  }
}
</style>